/**
 * Manually Created Assets Report.
 * @module advisor/components/reports/ManuallyCreatedAssetsReport
 *
 */

import React, {Component} from 'react';
import debug from 'debug';
import {connect} from 'react-redux';
import axiosInstance from '../../../shared/utils/axios';
import {Button, DescriptiveText} from '../../../shared';
import {_openModal} from '../../../shared/reducers/modals';
import {_getUnreadReports, isEntitled} from '../../../shared/store';
import PropTypes from 'prop-types';

const log = debug('circleblack:report:manuallyCreatedAssetsReport');

/**
 * Manually Created Assets Report component.
 *
 * @name ManuallyCreatedAssetsReport
 * @requires module:shared/components/Button
 *
 */
class ManuallyCreatedAssetsReport extends Component {
  constructor(props) {
    super(props);
    this.report = props.report;
    this.firm = props.session.profile.firm;
    this.state = {
      params: this.setupParams(this.report, this.firm),
      step: 1,
    };
    log('constructor state', this.state);
  }

  setupParams = (report, firm) => {
    log('setupParams');
    for (let i = 0; i < report.parameters.length; ++i) {
      if (report.parameters[i].name === 'firmID') {
        return {
          id: report.parameters[i].id,
          value: firm.id,
        };
      }
    }
  };

  generateReport = () => {
    if (!isEntitled([{group: 'compliance', feature: 'core', access: 'r'}])) {
      return;
    }

    return axiosInstance.post(
      '/reports/' + this.report.name,
      {parameters: [this.state.params]}
    )
      .then(() => {
        this.setState({
          message: 'Success! Your report is being generated and you will receive a notification when it is ready.',
          step: this.state.step + 1,
        });

        this.props.getUnreadReports(
          this.props.unreadReportsTimeoutID, this.props.unreadReports, this.props.reportPageVisitTimestamp, 30000
        );
      })
      .catch(err => this.props.openModal({
        type: 'MessageModal',
        title: err.response && err.response.data && err.response.data.error && err.response.data.error.title !== undefined
          ? err.response.data.error.title
          : 'Report Couldn\'t be created',
        body: (err.response && err.response.data && err.response.data.error && err.response.data.error.msg) || err.message,
      }));
  };

  render() {
    log('rendering', this.props);
    const {
      params,
      step,
    } = this.state;
    log('params', params);

    const renderStep = () => {
      log('renderStep', 'params', this.state.params);
      switch (step) {
        case 1:
          return (
            <div>
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <DescriptiveText>The Manually Created Assets Report displays a list of all manual accounts included in your firm's
                total historical balance.</DescriptiveText>
              <Button importance={'secondary'} size={'md'} label={'Generate'} disabled={false} action={this.generateReport}/>
            </div>
          );
        case 2:
          return (
            <div>
              <DescriptiveText>{this.state.message}</DescriptiveText>
            </div>
          );
        default:
          return <div>Something went wrong</div>; // TODO Update Manually Created Assets to Report to use steps component? There is only 1 step....
      }
    };
    return renderStep(step);
  }
}

const mapStateToProps = state => ({
  session: state.session,
  unreadReportsTimeoutID: state.badges.unreadReportsTimeoutID,
  unreadReports: state.badges.unreadReports,
  reportPageVisitTimestamp: state.badges.reportPageVisitTimestamp,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getUnreadReports: (timeoutID, unread, timestamp, interval) => dispatch(_getUnreadReports(timeoutID, unread, timestamp, interval)),
});

ManuallyCreatedAssetsReport.propTypes = {
  /**
   * The Report to be generated
   */
  report: PropTypes.shape({}).isRequired,
  /**
   * Is from Modals Reducer
   */
  openModal: PropTypes.func.isRequired,
  /**
   /**
   * Is Session Reducer
   */
  session: PropTypes.shape({
    profile: PropTypes.shape({
      firm: PropTypes.shape({
        id: PropTypes.number.isRequired,
        createdAt: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  /**
   * Are from badges reducer
   */
  getUnreadReports: PropTypes.func,
  unreadReportsTimeoutID: PropTypes.object,
  unreadReports: PropTypes.object,
  reportPageVisitTimestamp: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManuallyCreatedAssetsReport);
